// src/util/sdkLoader.js
// MVP: Sharetribe SDK removed.
// Compatibility shim so legacy imports continue to compile while we progressively delete
// Sharetribe-specific code paths.

const disabledError = (fnName = 'Sharetribe SDK') =>
  new Error(`${fnName} is disabled in this MVP. Use our /api/* endpoints instead.`);

/**
 * createInstance (Sharetribe) replacement
 */
export const createInstance = () => {
  throw disabledError('createInstance');
};

/**
 * transit replacement
 */
export const transit = {
  write: value => JSON.stringify(value),
  read: value => {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
};

/**
 * types replacement
 */
class UUID {
  constructor(uuid) {
    this.uuid = uuid;
  }
  toString() {
    return this.uuid;
  }
}

class Money {
  constructor(amount, currency) {
    this.amount = amount;
    this.currency = currency;
  }
}

class LatLng {
  constructor(lat, lng) {
    this.lat = lat;
    this.lng = lng;
  }
}

class LatLngBounds {
  constructor(ne, sw) {
    this.ne = ne;
    this.sw = sw;
  }
}

class BigDecimal {
  constructor(value) {
    this.value = value;
  }
  toString() {
    return String(this.value);
  }
}

export const types = {
  UUID,
  Money,
  LatLng,
  LatLngBounds,
  BigDecimal,
};

/**
 * util replacement (THIS fixes your current build error)
 * Some ducks import { util as sdkUtil } from sdkLoader.
 * Provide minimal helpers. Add more if a future compile/runtime error points to a missing method.
 */
export const util = {
  // Common Flex util used in FTW code: compare entities by id
  isSameEntity: (a, b) => {
    const aId = a?.id?.uuid || a?.id || a?.uuid;
    const bId = b?.id?.uuid || b?.id || b?.uuid;
    return !!aId && !!bId && String(aId) === String(bId);
  },

  // Some code checks if object is an "SDK entity" (very lightweight heuristic)
  isSDKEntity: obj => !!obj && typeof obj === 'object' && ('id' in obj || 'type' in obj),

  // Fallback that makes missing util calls obvious if they happen at runtime
  _disabled: name => {
    throw disabledError(`sdkUtil.${name}`);
  },
};

/**
 * createImageVariantConfig replacement
 */
export const createImageVariantConfig = (variants = []) => {
  return { variants };
};

export default {
  createInstance,
  transit,
  types,
  util,
  createImageVariantConfig,
};